import Splide from "@splidejs/splide";

document.addEventListener("DOMContentLoaded", function () {
  const blocks = document.querySelectorAll(".trustpilot-testimonial-block");

  if (!blocks.length) return;

  blocks.forEach(function (block) {
    const slider = block.querySelector(".trustpilot-reviews.splide");
    if (!slider) return;

    const splide = new Splide(slider, {
      type: "loop",
      perPage: 1,
      perMove: 1,
      gap: "2.4rem",
      arrows: false,
      pagination: false,
      autoplay: false,
      mediaQuery: "min",
      breakpoints: {
        992: {
          perPage: 2,
        },
      },
    }).mount();

    const prevBtns = block.querySelectorAll(".trustpilot-testimonial-arrow.-prev");
    const nextBtns = block.querySelectorAll(".trustpilot-testimonial-arrow.-next");

    prevBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        splide.go("<");
      });
    });

    nextBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        splide.go(">");
      });
    });
  });
});
